export default __webpack_public_path__ + "static/media/institute-1-min.4d45344e.webp";